// Homes Placeholder SVG
export const FALLBACK_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/ce1501221958405990f1d0d7fe935c51.svg?preset=square-2048';
